import React, { useState } from 'react'
import { Element } from '../../../../common/html/element'
import { Cell } from '../../../../common/table/Cell'
import withConditionRender from '../../hoc/withConditionRender'
import { selectCellData } from '../store/slice'

const Row = ({ schema, rowId, rowIndex }) => {
  const [isHovered, setIsHovered] = useState(false)

  const onMouseEnter = () => {
    setIsHovered(true)
  }

  const onMouseLeave = () => {
    setIsHovered(false)
  }

  return (
    <Element
      elementName="tr"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      style={{ backgroundColor: isHovered ? '#ccc' : 'transparent' }}
    >
      {schema.map(({ colId, render, tdStyle, renderCustom }) => {
        return (
          <Cell
            key={colId}
            colId={colId}
            getDataFromRedux={selectCellData}
            rowId={rowId}
            rowIndex={rowIndex}
            render={render}
            renderCustom={renderCustom}
            tdStyle={tdStyle}
            isHovered={isHovered}
          />
        )
      })}
    </Element>
  )
}

export default withConditionRender(Row)
